/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';

@Injectable()
export class DialogComponentService {
  private dialogStack: number[] = [];

  get getDialogList(): number[] {
    return this.dialogStack;
  }
  get getLast(): number {
    return this.dialogStack[this.dialogStack.length - 1];
  }

  addDialog(dialog: number): void {
    this.dialogStack.push(dialog);
  }

  removeDialog(time: number): void {
    this.dialogStack.splice(this.dialogStack.indexOf(time), 1);
  }

  isLast(time: number): boolean {
    return this.dialogStack.indexOf(time) === this.dialogStack.length - 1;
  }
}
